import {
  Popup,
  TPopupComponent,
} from '../../../../../../../shared/components/popup/popup.abstract.tsx';
import { TPopupDefaultActions } from '../../../../../../../shared/components/popup/services/popup.service.ts';
import { FC, useEffect, useMemo, useState } from 'react';
import { ContentPopup } from './content.popup.tsx';
import { map } from 'rxjs';

export class DoughsSplittingPopup extends Popup<IDoughsSplittingPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const Wrapper = useMemo(() => this.Wrapper, []);
      const [popupTitle, setPopupTitle] = useState('');

      useEffect(() => {
        stream
          .actionListener('open')
          .pipe(map(({ title }) => `${title}`))
          .subscribe(setPopupTitle);
      }, []);

      return (
        <Wrapper
          stream={stream}
          slotProps={{
            paper: { sx: { maxWidth: 1288, width: '100%', maxHeight: 450, height: '100%' } },
          }}
          fullWidth
          {...{ popupTitle }}
        >
          <ContentPopup stream={stream} />
        </Wrapper>
      );
    };
  }
}

export interface IDoughsSplittingPopup {
  action: TPopupDefaultActions;
  date: Date;
  title: string;
}
